import Cookies from 'js-cookie'

const getSubdomain = (domain) => {
    if (domain.includes('://')) {
        domain = domain.split('://')[1]
    }
    const subdomain = domain.split('.')[0]
    return subdomain
}

const getCookies = (key) => {
    try {
        const cookie = JSON.parse(Cookies.get(key))
        return cookie
    } catch (error) {
        return null
    }
}

const setCookies = (key, value) => {
    Cookies.set(key, value)
    return
}

export { getSubdomain, getCookies, setCookies }
